import { useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '~/services/api';
import { useAppStore } from '~/stores/useAppStore';
import { loggerUtils } from '~/services/logger';

export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const appStore = useAppStore();

  const logout = async () => {
    try {
      // Call backend logout API
      await api.logout();
      loggerUtils.auth('logout', { success: true });
    } catch (error) {
      loggerUtils.auth('logout', {
        error: error instanceof Error ? error.message : String(error),
        success: false
      });
      // Continue with logout even if API call fails
    }

    // Clear React Query cache (session data)
    queryClient.setQueryData(['session'], {
      authenticated: false,
      user: null,
    });

    // Invalidate all queries to force fresh fetch on next login
    queryClient.clear();

    // Clear Zustand app store state
    appStore.getState().setUser(null);
    appStore.setState({
      projects: [],
      buckets: [],
      folders: [],
      error: ''
    });

    // Navigate to login
    navigate('/login', { replace: true });
  };

  return logout;
}
